// Calls fn once the calls have stopped for `wait` ms, with the arguments of the last one.
// cancel() drops a call that is still waiting.
export const debounce = (fn, wait) => {
  let timer;
  const debounced = (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), wait);
  };
  debounced.cancel = () => clearTimeout(timer);
  return debounced;
};
